import { RouteProps } from 'src/router/types';
import { Navigate } from 'react-router-dom';
import UsersPanel from './UsersPanel';
import CustomersPanel from './CustomersPanel';

const ROUTE_USERS = 'users';
const ROUTE_CUSTOMERS = 'customers';

export const routes: RouteProps[] = [
  {
    index: true,
    element: <Navigate to={ROUTE_USERS} replace />,
  },
  {
    path: ROUTE_USERS,
    element: <UsersPanel />,
    meta: {
      title: 'Users',
    },
  },
  {
    path: ROUTE_CUSTOMERS,
    element: <CustomersPanel />,
    meta: {
      title: 'Customers',
    },
  },
];
